module.exports = __webpack_public_path__ + "img/icon-empty-steps.031d2f59.svg";